"use client";

import React from "react";
import { MapPin, Phone, Mail, Building2 } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const locations = [{
  id: 1,
  name: "ABCO South Headquarters",
  address: "123 Industrial Pkwy, Atlanta, GA 30301",
  phone: "(555) 123-4567",
  email: "hq@abcosouth.com",
  mapX: "35%",
  mapY: "45%"
}, {
  id: 2,
  name: "Regional Distribution Center",
  address: "456 Logistics Blvd, Dallas, TX 75201",
  phone: "(555) 987-6543",
  email: "dallas.dist@abcosouth.com",
  mapX: "45%",
  mapY: "65%"
}, {
  id: 3,
  name: "Manufacturing Plant",
  address: "789 Assembly Ln, Charlotte, NC 28202",
  phone: "(555) 456-7890",
  email: "charlotte.mfg@abcosouth.com",
  mapX: "60%",
  mapY: "40%"
}, {
  id: 4,
  name: "Gulf Coast Operations",
  address: "101 Port Ave, Houston, TX 77001",
  phone: "(555) 222-3333",
  email: "houston.ops@abcosouth.com",
  mapX: "48%",
  mapY: "75%"
}, {
  id: 5,
  name: "Florida Logistics Hub",
  address: "202 Sunshine Way, Orlando, FL 32801",
  phone: "(555) 444-5555",
  email: "orlando.hub@abcosouth.com",
  mapX: "70%",
  mapY: "80%"
}, {
  id: 6,
  name: "Midwest Forwarding",
  address: "303 Transit Rd, Memphis, TN 38101",
  phone: "(555) 666-7777",
  email: "memphis.fwd@abcosouth.com",
  mapX: "50%",
  mapY: "50%"
}];
export default function OurLocations() {
  return;
}